module.exports = __webpack_public_path__ + "img/concierge-service.f9b110d8.png";